/* eslint-disable @typescript-eslint/no-unused-vars */
import { RecipeHeader } from 'common/src/api/models/recipe-header.models';
import { useRef, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

export type SecretRecipeRowActionsState =
  | {
      anchor?: HTMLElement;
      recipeHeader?: RecipeHeader;
      menuOpen: boolean;
    }
  | undefined;

const initState = undefined;

let openRowActions = (anchor?: HTMLElement, recipeHeader?: RecipeHeader): void => {
  console.warn('use useRecipeRowActions hook to access this method');
};

let closeRowActions = (): void => {
  console.warn('use useRecipeRowActions hook to access this method');
};

let toggleRowActions = (anchor?: HTMLElement, recipeHeader?: RecipeHeader): void => {
  console.warn('use useRecipeRowActions hook to access this method');
};

export const useSecretRecipeRowAction = singletonHook<SecretRecipeRowActionsState>(initState, () => {
  const [state, setState] = useState<SecretRecipeRowActionsState>(initState);
  const stateRef = useRef<SecretRecipeRowActionsState>(initState);

  openRowActions = (anchor?: HTMLElement, recipeHeader?: RecipeHeader) => {
    stateRef.current = { anchor, recipeHeader, menuOpen: true };
    setState(stateRef.current);
  };
  closeRowActions = () => {
    stateRef.current = initState;
    setState(initState);
  };
  toggleRowActions = (anchor?: HTMLElement, recipeHeader?: RecipeHeader) => {
    if (stateRef.current) {
      if (stateRef.current?.anchor === anchor) {
        closeRowActions();
      } else {
        openRowActions(anchor, recipeHeader);
      }
    } else {
      openRowActions(anchor, recipeHeader);
    }
  };

  return state;
});

export const toggleSecretRecipeRowActions = (anchor?: HTMLElement, recipeHeader?: RecipeHeader): void =>
  toggleRowActions(anchor, recipeHeader);
